import type {
  Action,
  Threshold,
  DataRoute,
  Dependency,
  WorkflowProps,
} from '../../engine/types';
import { sanitizeImportedActions } from '../helpers';
import type { WorkflowState } from '../state';
import type { Snapshot, SnippetMode } from '../types';

export function setSnippetMode(
  state: WorkflowState,
  action: {
    payload: {
      mode: SnippetMode | null;
    };
  },
) {
  const { mode } = action.payload;
  state.ui.snippet.mode = mode;
}

export function setPreSnippetWorkflowDataSnapshotId(
  state: WorkflowState,
  action: {
    payload: {
      snapshotId: Snapshot<unknown>['snapshotId'] | null;
    };
  },
) {
  const { snapshotId } = action.payload;
  state.ui.snippet.preSnippetWorkflowDataSnapshotId = snapshotId;
}

export function setPreSnippetWorkflowPropsSnapshot(
  state: WorkflowState,
  action: {
    payload: {
      snapshot: Snapshot<WorkflowProps> | null;
    };
  },
) {
  const { snapshot } = action.payload;
  state.ui.snippet.preSnippetWorkflowPropsSnapshot = snapshot;
}

export function setSnippetIncompatibleActions(
  state: WorkflowState,
  action: {
    payload: {
      actions: Action[];
    };
  },
) {
  const { actions } = action.payload;
  state.ui.snippet.incompatibleActions = actions;
}

export function setSnippetMetadata(
  state: WorkflowState,
  action: {
    payload: WorkflowState['snippet']['metadata'];
  },
) {
  state.snippet.metadata = action.payload;
}

export function setSnippetPreviewData(
  state: WorkflowState,
  action: {
    payload: {
      actions: Record<string, Action>;
      thresholds: Record<string, Threshold>;
      dataRoutes: Record<string, DataRoute>;
      dependencies: Record<string, Dependency[]>;
      workflowToken: string;
      name: string;
      publicVersion: number;
    };
  },
) {
  state.workflowData = {
    ...state.workflowData,
    actions: sanitizeImportedActions(action.payload.actions, state.workflowProps.allWorkflows),
    thresholds: action.payload.thresholds,
    dataRoutes: action.payload.dataRoutes,
    dependencies: action.payload.dependencies,
    validations: {
      timestamp: Date.now(),
      actions: [],
    },
    token: action.payload.workflowToken,
    name: action.payload.name,
    publicVersion: action.payload.publicVersion,
  };
}
